import {
    IconFileTypeJpg,
    IconFileTypePdf,
    IconFileTypePng,
    IconFileTypeSvg,
    IconPhoto,
    IconPhotoScan,
    IconWand,
} from '@tabler/icons-react';

/**
 * One icon per output format, shared by every place that offers the choice — the
 * settings card in the image tools and the picker in the NID / passport action
 * bar — so a format looks the same wherever it is picked.
 *
 * Tabler has a glyph for JPG and PNG but none for WebP or AVIF. Where they both
 * fell back to the plain photo the two menu rows were impossible to tell apart,
 * so AVIF takes the scan glyph — which is what the crop, convert and flatten
 * tools already gave it — leaving the plain photo to WebP.
 */
export const OUTPUT_FORMAT_ICONS = {
    original: IconWand,
    pdf: IconFileTypePdf,
    jpg: IconFileTypeJpg,
    png: IconFileTypePng,
    svg: IconFileTypeSvg,
    webp: IconPhoto,
    avif: IconPhotoScan,
};

export const outputFormatIcon = (id) => OUTPUT_FORMAT_ICONS[id] || IconPhoto;
